import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    
    <App />
  </React.StrictMode>
);

// https://www.tailwind-kit.com/templates/errors404

// https://xd.adobe.com/view/a1802132-23ab-4b87-930f-682c6e61fc84-f4d3/screen/902e013b-6a16-465f-8ff7-c0d1c2bcef40/specs/
 
// https://uxwing.com/map-pin-point-icon/
 
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals


//https://xd.adobe.com/view/a1802132-23ab-4b87-930f-682c6e61fc84-f4d3/
reportWebVitals();
